export const BotMessage = ({ children }) => {
  return (
    <div className="inline-flex max-w-[80%] flex-col gap-2 overflow-x-auto font-normal rounded-xl px-4 py-3 bg-gray-100 text-gray-900 rounded-tl-sm">
      <span className="max-w-none whitespace-pre-wrap">{children}</span>
    </div>
  );
};
